<app-auth-layout>
  <div class="cont" [ngClass]="page">
    <img class="logo" src="./assets/images/logo.svg" />

    <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="page === 'signin'">
      <app-error *ngIf="errCode" [errcode]="errCode" />
      <sync-alert
        type="info"
        *ngIf="showVerifiedMessage"
        [showLeadIcon]="true"
        leadIcon="info"
        [showActions]="false"
        [showCloseButton]="false"
        description="Your account has been verified, please log in."      
      />
      <sync-alert
        type="info"
        *ngIf="showPasswordResetMessage"
        [showLeadIcon]="true"
        leadIcon="info"
        [showActions]="false"
        [showCloseButton]="false"
        title="New password has been saved."
        description="Please sign in with your new password."      
      />
      <sync-alert
        type="info"
        *ngIf="showPasswordSetMessage"
        [showLeadIcon]="true"
        leadIcon="info"
        [showActions]="false"
        [showCloseButton]="false"
        title="Password has been set."
        description="Please sign in with your new password."      
      />

      <h1>Sign in</h1>
      
      <div class="fields">
        <sync-text-field
          id="text-auth-email"
          label="Email address"
          formControlName="emailAddress"
          [errorMessage]="getErrorMessage('emailAddress')"
          [onBlur]="onEmailBlur"
        />
        <sync-text-field
          id="text-auth-password"
          label="Password"
          inputType="password"
          formControlName="password"
          [errorMessage]="getErrorMessage('password')"
        />
      </div>

      <div class="row">
        <sync-checkbox
          class="remember-me"
          label="Keep me signed in"
        />

        <sync-button
          class="forgot-password"
          label="Forgot password?"
          type="flat"
          [onClick]="onClickForgotPassword"
        />
      </div>

      <div class="buttons">
        <sync-button
          id="btn-auth-login"
          nativeType="submit"
          label="Sign in"
          [isLoading]="spinner"
          [disabled]="form.invalid"
          buttonWidth="236px"
        />

        <span class="or">or</span>

        <sync-button
          label="Create an account"
          type="outlined"
          [onClick]="onClickCreateAccount"
          buttonWidth="236px"
        />
      </div>
    </form>

    <ng-container *ngIf="page === 'twofa'">
      <app-two-form-factor 
        (submitForm)="handleTwoFactor($event)"
        (resetToSignin)="onResetToSignin()"
        [spinner]="spinner"
      />
    </ng-container>
  </div>
</app-auth-layout>